// import "../../styles/theme.scss.liquid";
// import "../../styles/theme.scss";
import "./shopify_common.js";
import welcomeDiscountHandler from "../util/welcomeDiscount";
import customer from "../templates/customer.js";
import nav from "../sections/nav.js";
import collection from "../templates/collection";
import search from "../templates/search";
import index from "../templates/index";
import cart from "../templates/cart.js";
import faq from "../templates/page.faq.js";
import product from "../templates/product.js";
import { initCart } from "../sections/product-recommendation.js";
import { initATC } from "../sections/atc.js";
import wishlist from "../sections/wishlist.js";
import announcement from "../sections/announcement-banner.js";

let template = document.querySelector("body"),
    cartPage = template.classList.contains("template-cart"),
    searchPage = template.classList.contains("template-search"),
    address = template.classList.contains("template-customers-addresses"),
    productPage = template.classList.contains("template-product"),
    collectionPage = template.classList.contains("template-collection"),
    faqPage = template.classList.contains("template-page-faqs"),
    list = [];

template.classList.forEach(item => { list.push(item) })

if (typeof Cookies.get("gwp") !== "undefined") {
  Cookies.remove("gwp");
}
// On load, check for __kla_id
// If __kla_id does not exist, add loop that waits for the popup form submit button
// On submission of the popup form, add loop that waits for the 'start shopping' button to display
// On click of "start shopping", the "x" button, or closing out the modal in general, show the top banner that sticks with the customer across the site and add the welcome20 discount code to the user's shopping session
welcomeDiscountHandler();
initATC();
wishlist();
announcement();
nav();

if (collectionPage) {
  collection();
}
if (searchPage) {
  search();
}
if (productPage) {
  product();
}

if (address) {
  customer();
}

if (cartPage) {
  cart();
  initCart();
}

if (faqPage) {
  faq()
}

list.forEach(item => {
  if (item.includes("template-page")) {
    index()
  }
})
